import { render } from "./optionsAccount.vue?vue&type=template&id=5f9d8621&scoped=true"
import script from "./optionsAccount.vue?vue&type=script&lang=js"
export * from "./optionsAccount.vue?vue&type=script&lang=js"

import "./optionsAccount.vue?vue&type=style&index=0&id=5f9d8621&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9d8621"]])

export default __exports__